import type { Camera, Scene } from 'three';

import type { LightingManager } from '../lighting-manager.class';

/**
 * Configuration for BrightnessControl
 */
export type BrightnessControlConfig = {
	/** Three.js scene to add the control sphere into */
	scene: Scene;
	/** Active camera (used for raycasting and billboard orientation) */
	camera: Camera;
	/** Renderer DOM element for event binding */
	domElement: HTMLElement;
	/** LightingManager instance to adjust brightness through */
	lightingManager: LightingManager;
	/** World-space position of the brightness sphere */
	position?: { x: number; y: number; z: number };
	/** Radius of the brightness sphere */
	sphereRadius?: number;
	/** Base color of the sphere (hex) */
	sphereColor?: number;
	/** Pixels of vertical drag to traverse the full 0-1 brightness range */
	dragSensitivity?: number;
	/** Starting brightness (0 = dark, 1 = full brightness) */
	initialBrightness?: number;
};

/**
 * Default configuration values for BrightnessControl
 */
export const BRIGHTNESS_CONTROL_DEFAULTS: Partial<BrightnessControlConfig> = {
	position: { x: 15, y: 12, z: 15 },
	sphereRadius: 1.2,
	sphereColor: 0xffdd44,
	dragSensitivity: 0.004,
	initialBrightness: 1.0
};
